import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classNames from 'classnames';

import classes from './SelectedInfoRow.module.scss';

type SelectedInfoRowProps = {
  selectedItemCount: number;
  children: ReactNode;
  isSubGridRow?: boolean;
};

const SelectedInfoRow = ({
  selectedItemCount,
  children,
  isSubGridRow,
}: SelectedInfoRowProps) => {
  if (!selectedItemCount) {
    return null;
  }

  const rowClasses = classNames(classes.selectInfoRow, {
    [classes.subGridRow]: isSubGridRow,
  });

  return (
    <Surface className={rowClasses}>
      <p>{selectedItemCount} selected items</p>
      <div className={classes.optionsBox}>{children}</div>
    </Surface>
  );
};

export { SelectedInfoRow };
